module.exports = __webpack_public_path__ + "img/doc-md.d1cd947a.jpg";